const DEFAULT_CHUNK_SIZE = 10;

export async function deleteAllInChunks(
  ids: Array<string>,
  deleteFn: (id: string) => Promise<unknown>,
  onError: (error: Error) => void,
  chunkSize = DEFAULT_CHUNK_SIZE,
): Promise<void> {
  for (let i = 0; i < ids.length; i += chunkSize) {
    const chunk = ids.slice(i, i + chunkSize);
    try {
      await Promise.all(chunk.map(deleteFn));
    } catch (error) {
      onError(error instanceof Error ? error : new Error(String(error)));
      return;
    }
  }
}
